import { useSelector } from 'react-redux';
import { IViewVenuerexPopup } from '@bridebook/web/components/venuerex/view-venuerex-popup/index';
import { IApplicationState } from '@bridebook/web/lib/types';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const ViewVenuerexPopup = lazyComponent<IViewVenuerexPopup>(
  () => import('@bridebook/web/components/venuerex/view-venuerex-popup'),
);

interface LazyViewVenuerexPopupProps {}

const LazyViewVenuerexPopup: React.FC<LazyViewVenuerexPopupProps> = () => {
  const show = useSelector<IApplicationState, boolean>(
    (state) => state.venuerex.showGoToVenuerexPageModal,
  );

  if (!show) return null;

  return <ViewVenuerexPopup showGoToVenuerexPageModal={show} />;
};

export default memo(LazyViewVenuerexPopup);
